import React, { useEffect, useMemo } from 'react';

import FeedbackForm from '../../util/FeedbackForm';

const classes = {
	mainContainer: {
		display: 'flex',
		flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row' },
		marginX: 0,
		marginTop: { xs: '0', sm: '0', md: '16px', lg: '16px', xl: '16px' },
		maxHeight: `calc(100vh - 96px)`,
		overflow: { xs: 'auto', sm: 'auto', md: 'none', lg: 'none', xl: 'none' },
	},
	cardContainer: {
		flexBasis: { xs: 'unset', sm: 'unset', md: '20%', lg: '20%', xl: '20%' },
		marginRight: { xs: '0', sm: '0', md: '16px', lg: '16px', xl: '16px' },
		display: { md: 'flex', lg: 'flex' },
		flexDirection: { md: 'row-reverse', lg: 'row-reverse' },
		maxHeight: { xs: 'unset', sm: 'unset', md: '440px', lg: '440px', xl: '440px' },
		overflow: { xs: 'unset', sm: 'unset', md: 'auto', lg: 'auto', xl: 'auto' },
	},
	formContainer: {
		padding: 2,
		marginBottom: 1,
		backgroundColor: 'background.paper',
		height: '100%,',
		flexBasis: { sx: 'unset', sm: 'unset', md: '80%', lg: '80%', xl: '80%' },
		overflow: { xs: 'none', sm: 'none', md: 'auto', lg: 'auto', xl: 'auto' },
	},
};
const NewUI = ({
	data,
	responses,
	setResponses,
	setRequiredQuestions,
	handleOnSaveButtonClick,
	handleOnSubmitButtonClick,
	theme,
	handleChange,
}) => {
	const {
		intervieweeName: candidate,
		feedbackState,
		requestedOn,
		recruiter,
		interviewer,
		hiringManager,
		jobTitle,
		initialResponses,
		formCard,
		feedbackRequestStatus,
		questionGroupName,
		customerId,
		jobId,
		intervieweeId,
	} = data;
	const cardDetails = {
		candidate,
		requestedOn,
		recruiter,
		interviewer,
		hiringManager,
		jobTitle,
		feedbackState,
		customerId,
		jobId,
		intervieweeId,
	};
	const updatedformCard = useMemo(
		() => ({ ...formCard, actions: null, body: formCard.body.slice(1) }),
		[formCard],
	);

	useEffect(() => {
		const reqQuestions = [];
		formCard.body.forEach(({ id, isRequired }) => {
			if (isRequired) {
				reqQuestions.push(id);
			}
		});
		setRequiredQuestions(reqQuestions);
	}, [formCard, setRequiredQuestions]);
	return (
		<div data-testid="feedback-new-ui">
			<FeedbackForm
				cardDetails={cardDetails}
				initialResponses={initialResponses}
				responses={responses}
				formCard={updatedformCard}
				title={questionGroupName}
				setResponses={setResponses}
				handleOnSaveButtonClick={handleOnSaveButtonClick}
				handleOnSubmitButtonClick={handleOnSubmitButtonClick}
				isPending={false}
				feedbackRequestStatus={feedbackRequestStatus}
				theme={theme}
				disableEdit={false}
				containerClass={classes.mainContainer}
				cardContainerClass={classes.cardContainer}
				formContainerClass={classes.formContainer}
				handleChange={handleChange}
			/>
		</div>
	);
};

export default NewUI;
